import {
  app
} from '../constants';

/**
 * Import constants
 */
const {
  SET_PROJECT,
  SET_DISTRICT,
  SET_LANG,
  SET_UUID,
  SET_RUNS_ON,
  SET_IS_PREVIEW,
  SET_ACCOUNT_ID,
  SET_APP_STAGE,
  SET_WHOLE_APP_DATA,
  SET_KIDS_DATA,
  SET_LM_DATA,
  SET_RR_GAME_ONLY,
  SET_APP_VERSION,
  SET_MAIN_COLOR,
  SET_APIGW_PREFIX,
  SET_DZ_BRAND_CONFIGS
} = app;

/**
 * Action creators
 */
const actions = {
  setLMData: (data) => ({ type: SET_LM_DATA, data }),
  setProject: (data) => ({ type: SET_PROJECT, data }),
  setDistrict: (data) => ({ type: SET_DISTRICT, data }),
  setLang: (data) => ({ type: SET_LANG, data }),
  setAppVersion: (data) => ({ type: SET_APP_VERSION, data }),
  setMainColor: (data) => ({ type: SET_MAIN_COLOR, data }),
  setRrGameOnly: (data) => ({ type: SET_RR_GAME_ONLY, data }),
  setUuid: (data) => ({ type: SET_UUID, data }),
  setRunsOn: (data) => ({ type: SET_RUNS_ON, data }),
  setIsPreview: (data) => ({ type: SET_IS_PREVIEW, data }),
  setAccountId: (data) => ({ type: SET_ACCOUNT_ID, data }),
  setApiGWPrefix: (data) => ({ type: SET_APIGW_PREFIX, data }),
  setDzBrandConfigs: (data) => ({ type: SET_DZ_BRAND_CONFIGS, data }),
  setAppStage: (data) => ({ type: SET_APP_STAGE, data }),
  setKidsData: (data) => ({ type: SET_KIDS_DATA, data }),
  setWhole: (data) => ({ type: SET_WHOLE_APP_DATA, data })
};

/**
 * Set whole app data coming from mobile
 */
export const setWhole = (data) => (dispatch) => dispatch(actions.setWhole(data));

/**
 * Set project id
 */
export const setProjectId = (projectId) => (dispatch) => dispatch(actions.setProject(projectId));

export const setLMData = (data) => (dispatch) => dispatch(actions.setLMData(data));

/**
 * Set district id
 */
// eslint-disable-next-line max-len
export const setDistrictId = (districtId) => (dispatch) => dispatch(actions.setDistrict(districtId));

/**
 * Set lang
 */
export const setLanguage = (lang) => (dispatch) => dispatch(actions.setLang(lang));

/**
 * Set setRrGameOnly
 */
export const setRrGameOnly = (value) => (dispatch) => dispatch(actions.setRrGameOnly(value));

/**
 * Set uuid
 */
export const setUuid = (uuid) => (dispatch) => dispatch(actions.setUuid(uuid));

/**
 * Set Runson
 */
export const setRunsOn = (device) => (dispatch) => dispatch(actions.setRunsOn(device));

/**
 * Set is campaign preview
 */
export const setIsPreview = (isWebapp) => (dispatch) => dispatch(actions.setIsPreview(isWebapp));

/**
 * Set account id
 */
export const setAccountId = (accountId) => (dispatch) => dispatch(actions.setAccountId(accountId));

export const setApiGWPrefix = (data) => (dispatch) => dispatch(
  actions.setApiGWPrefix(data)
);
export const setDzBrandConfigs = (data) => (dispatch) => dispatch(
  actions.setDzBrandConfigs(data)
);

export const setAppStage = (stage) => (dispatch) => dispatch(actions.setAppStage(stage));

export const setAppVersion = (stage) => (dispatch) => dispatch(actions.setAppVersion(stage));

export const setMainColor = (stage) => (dispatch) => dispatch(actions.setMainColor(stage));

/**
 * Set kids data
 */
export const setKidsData = (data) => (dispatch) => dispatch(actions.setKidsData(data));
